import { ITransportDetailSection } from 'types/transport'
import CustomSelect, { ISelectOption } from 'components/common/CustomSelect';
import { blStatusSelect, stepStatusSelect } from 'data/transport';
import DetailInfoArea from 'components/transport/DetailInfoArea';
import Loading from 'components/common/Loading';
import { jsonAxios } from 'components/axios';
import { toast } from 'react-toastify';

const DocumentCutoff = ({ detailInfo, type, loading, transportInfo }: ITransportDetailSection) => {
    const statusDefault = (option: ISelectOption[]): ISelectOption => {
        if (!detailInfo) return option[0] as ISelectOption
        if (!detailInfo.stepStatus) return option[0] as ISelectOption
        const status = detailInfo.stepStatus.toString();

        const filtered = option.filter(arr => arr.value === status);
        if (!filtered) return option[0] as ISelectOption
        return filtered[0]
    }

    if (loading) return <div className='flex justify-center items-center h-96'><Loading /></div>

    const saveBlType = (type: string) => {
        const reqData = {
            orderId: transportInfo?.id,
            blType: type
        }
        jsonAxios.post('order', reqData).then(res => {
            if (res.data.code === 200) {
                toast.success('정상적으로 수정되었습니다.')
            }
        })
    }

    return (
        <div className='flex flex-col justify-start items-start gap-6 px-10 py-6 text-lg'>
            <div className={`flex items-center`}>
                {/* {JSON.stringify(detailInfo)} */}
                <div className="w-[150px] text-lg shrink-0">
                    <p>BL타입</p>
                </div>
                <div className={`flex items-center min-w-[600px] bg-[#F8F8FA] rounded h-10`}>
                    <CustomSelect
                        height={40}
                        fontSize={14}
                        disabled={detailInfo?.stepStatus === 1}
                        option={blStatusSelect}
                        defaultValue={
                            detailInfo?.detailInfo?.blType !== undefined
                                ? blStatusSelect.find(arr => arr.value === detailInfo?.detailInfo?.blType)
                                : undefined
                        }
                        placeholder={'BL 타입 선택'}
                        onChange={(value) => {
                            saveBlType(value)
                        }}
                    />
                </div>
            </div>
            <DetailInfoArea
                title='BL.No'
                value={detailInfo?.detailInfo?.blNo ?? ''}
            />
            <DetailInfoArea
                title='운송단계상태'
                value={statusDefault(stepStatusSelect).label}
            />

            <DetailInfoArea
                title='선적서류접수일시'
                value={detailInfo?.detailInfo?.receivedAt ?? ''}
            />
            <DetailInfoArea
                title='선적서류마감일시'
                value={detailInfo?.detailInfo?.cutoffAt ?? ''}
            />
        </div>
    )
}

export default DocumentCutoff